/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2020-04-01 15:17:07
 */
import instance from './http.config.js'

export const sendCode = params => instance.post('/player/login/send-code', params)
// reflection
export const sendCodeReflection = params => instance.post('/player/summary_login/send-code', params)
export const loginHander = params => instance.post('/player/login', params)
// reflextion
export const loginReflectionHander = params => instance.post('/player/summary_login', params)
export const getActivityInfo = activityId => instance.get(`/v2/admin/activitys/${activityId}/`)



// WEBPACK FOOTER //
// ./src/service/login.js